import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { OrdersApiAdapter } from '../adapters/OrdersApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new OrdersApiAdapter(httpClient);

export const usePaymentCorrections = () => {
  const { orderId } = useParams<{ orderId: string }>();

  return useQuery({
    queryKey: ['paymentCorrections', orderId],
    queryFn: async () => {
      if (!orderId) return [];
      const response = await adapter.getPaymentCorrections(Number(orderId));
      return response.data ?? [];
    },
    enabled: Boolean(orderId),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
